import PropTypes from 'prop-types';
import React from 'react';

import './Info.less';

const Info = (props) => {
    const {
        family,
        siteInfo
    } = props;

    if (!siteInfo && !family) {
        return null;
    }

    return (
        <div className="SiteFooter__info">
            {siteInfo &&
                <div>
                    <h3>{siteInfo.title}</h3>
                    {siteInfo.userLinks &&
                        <ul className="list-unstyled">{siteInfo.userLinks.map((link, index) =>
                                <li key={index}>
                                    <a href={link.link} target="_blank">{link.text}</a>
                                </li>
                            )}
                        </ul>
                    }
                    <h3>{siteInfo.companyTitle}</h3>
                    {siteInfo.companyLinks &&
                        <ul className="list-unstyled">{siteInfo.companyLinks.map((link, index) =>
                            <li key={index}>
                                <a href={link.link} target="_blank">{link.text}</a>
                            </li>
                            )}
                        </ul>
                    }
                </div>
            }
            {family && family.sites &&
                <div className="SiteFooter__info__family">
                    <h3>{family.title}</h3>
                    <ul className="list-unstyled">{family.sites.map((link, index) =>
                        <li key={index}>
                            <a href={link.link} target="_blank">{link.text}</a>
                        </li>
                        )}
                    </ul>
                </div>
            }
        </div>
    );
};

Info.propTypes = {
    family: PropTypes.shape({}),
    siteInfo: PropTypes.shape({})
};

export default Info;
